<template>
  <div>
    <!-- 认证失败区 -->
    <div v-if="showFailReason" class="auth-fail">
      <div class="dot_">
      <img src="../../../assets/image/nsale/dot.svg" alt="">
      </div>
      <p class="result_">认证失败！</p>
      <p class="title_">{{ failReason }}</p>
      <div>
        <cube-button class="backbtn_" @click="showFailReason=false">重新认证</cube-button>
      </div>
    </div>
    <!-- 认证区域 -->
    <div v-else class="auth">
      <p class="title_">
        依照保监要求，为了保障您的利益，请准确填写以下实名信息。本平台将通过保监会官方渠道验证您的资质，并郑重承诺对您所提供对个人以及相关验证信息严格保密
      </p>
      <p class="text">可点击在线查询资质信息<span class="red" @click="goPage">《保险中介从业人员查询》</span></p>
      <div class="con_">
        <div class="con_1">
          <span class="tit_">用户名：</span>
          <cube-input placeholder="请输入用户名" style="width: 100%;" v-model="authName" readonly>
          </cube-input>
        </div>
        <div class="con_1">
          <span class="tit_">真实姓名：</span>
          <cube-input placeholder="请输入您的真实姓名" style="width: 100%;" v-model="name">
          </cube-input>
        </div>
        <div class="con_1">
          <span class="tit_">证件类型：</span>
          <input class="picker" v-model="idTypeText" readonly @click="showPicker()" />
        </div>
        <!-- <div class="con_1">
          <span class="tit_">证件类型：</span>
          <cube-select style="width: 100%;">
          </cube-select>
        </div> -->
        <div class="con_1">
          <span class="tit_">证件号码：</span>
          <cube-input placeholder="请输入证件号码" style="width: 100%;" v-model="idNumber">
          </cube-input>
        </div>
        <div class="con_1">
          <span class="tit_">执业证编号：</span>
          <cube-input type="number" placeholder="请输入执业证编号" style="width: 100%;" v-model="license">
          </cube-input>
        </div>
        <div class="con_1">
          <span class="tit_">所属公司：</span>
          <cube-input placeholder="请输入所属公司" style="width: 100%;" v-model="company">
          </cube-input>
        </div>
      </div>
      <div class="read_">
        <cube-checkbox shape="square" v-model="checked">
          <span :class="{is_black:checked}">我已阅读并同意</span>
        </cube-checkbox>
        <span class="is_read" @click="readAuth">《核查职业资格授权书》</span>
      </div>
      <div>
        <cube-button class="btn_" :class="{greybtn_: !checked,okbtn_: checked}" @click="checked ? toAuth() : ''">资质认证</cube-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import checkIdCard from '@/utils/checkIdCard'
let _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
export default {
  data () {
    document.title = '资质认证'
    return {
      showFailReason: false,
      failReason: '', // 认证失败原因
      checked: false,
      isPass: true,
      authName: '',
      idType: '',
      idTypeText: '',
      name: '',
      idNumber: '',
      company: '',
      license: '',
      key: '',
      backUrl: '',
      // 证件类型
      idTypeOpts: [
        {
          value: '1',
          text: '身份证'
        },
        {
          value: '3',
          text: '台胞证'
        },
        {
          value: '2',
          text: '港澳通行证'
        }
      ]
    }
  },
  created () {
    let { checked, authName, key, name, idNumber, company, license, realName, idType, idTypeText, isPass, fail } = this.$route.query

    if(isPass === '2') {
      this.showFailReason = true
      this.failReason = fail
    }

    if (!realName) {
      localStorage.setItem('key', key)
      this.key = key
    } else {
      this.key = localStorage.getItem('key')
    }
    let authentication = sessionStorage.getItem('authentication') ? JSON.parse(sessionStorage.getItem('authentication')) : {}
    this.checked = checked
    this.authName = authName || (realName || authentication.authName)
    this.name = name || authentication.name
    this.idNumber = idNumber || authentication.idNumber
    this.idType = idType || authentication.idType
    this.idTypeText = idTypeText || authentication.idTypeText
    this.license = license || authentication.license
    this.company = company || authentication.company
  },
  methods: {
    goPage () {
      sessionStorage.setItem('authentication', JSON.stringify(
        {
          checked: this.checked,
          authName: this.authName,
          name: this.name,
          idNumber: this.idNumber,
          idType: this.idType,
          idTypeText: this.idTypeText,
          license: this.license,
          company: this.company
        }
      ))
      window.location.href = 'http://iir.circ.gov.cn/'
    },
    showPicker () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '',
          data: [this.idTypeOpts],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      this.idType = selectedVal[0]
      this.idTypeText = selectedText[0]
    },
    cancelHandle () {
      // this.$createToast({
      //   type: 'correct',
      //   txt: '已取消选择',
      //   time: 1000
      // }).show()
    },
    readAuth () {
      this.$router.push({
        path: '/bs/authpage',
        query: {
          authName: this.authName,
          name: this.name,
          idNumber: this.idNumber,
          idType: this.idType,
          idTypeText: this.idTypeText,
          license: this.license,
          company: this.company
        }
      })
    },
    toAuth () {
      if (this.name == '') {
        this.$toast('真实姓名不能为空')
        return false
      }
      if (this.idType == '1' && !checkIdCard(this.idNumber)) {
        this.$toast('请输入正确的证件号码')
        return false
      } else if (!this.idNumber) {
        this.$toast('请输入证件号码')
        return false
      }
      if (!this.license) {
        this.$toast('请输入执业证编号')
        return false
      }
      if (!this.company) {
        this.$toast('请输入所属公司')
        return false
      }
      let params = {
        idType: this.idType,
        name: this.name,
        idNumber: this.idNumber,
        license: this.license,
        company: this.company,
        userId: this.key
      }
      api.qualificationAuthentication(params).then(r => {
        console.log(r, '------')
        let returnCode = r.data.returnCode
        let isPass = r.data.content
        // let isPass = '2'
        // if (returnCode == '0000' && content == '1') {
        //   isPass = '1'
        // }
        this.$router.push({
          path: '/bs/authResult',
          query: {
            isPass
          }
        })
      })
    },

    encode (input) {
      var output = ''
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4
      var i = 0
      const _utf8_encode = (string) => {
        string = string.replace(/\r\n/g, '\n')
        var utftext = ''
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n)
          if (c < 128) {
            utftext += String.fromCharCode(c)
          } else if ((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192)
            utftext += String.fromCharCode((c & 63) | 128)
          } else {
            utftext += String.fromCharCode((c >> 12) | 224)
            utftext += String.fromCharCode(((c >> 6) & 63) | 128)
            utftext += String.fromCharCode((c & 63) | 128)
          }
        }
        return utftext
      }
      input = _utf8_encode(input)
      while (i < input.length) {
        chr1 = input.charCodeAt(i++)
        chr2 = input.charCodeAt(i++)
        chr3 = input.charCodeAt(i++)
        enc1 = chr1 >> 2
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
        enc4 = chr3 & 63
        if (isNaN(chr2)) {
          enc3 = enc4 = 64
        } else if (isNaN(chr3)) {
          enc4 = 64
        }
        output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4)
      }
      return output
    },

    decode (input) {
      var output = ''
      var chr1, chr2, chr3
      var enc1, enc2, enc3, enc4
      var i = 0
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
      while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++))
        enc2 = _keyStr.indexOf(input.charAt(i++))
        enc3 = _keyStr.indexOf(input.charAt(i++))
        enc4 = _keyStr.indexOf(input.charAt(i++))
        chr1 = (enc1 << 2) | (enc2 >> 4)
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
        chr3 = ((enc3 & 3) << 6) | enc4
        output = output + String.fromCharCode(chr1)
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2)
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3)
        }
      }
      output = this._utf8_decode(output)
      return output
    },
    _utf8_decode (utftext) {
      var string = ''
      var i = 0
      var c = 0
      var c1 = 0
      var c2 = 0
      while (i < utftext.length) {
        c = utftext.charCodeAt(i)
        if (c < 128) {
          string += String.fromCharCode(c)
          i++
        } else if ((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i + 1)
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
          i += 2
        } else {
          c2 = utftext.charCodeAt(i + 1)
          var c3 = utftext.charCodeAt(i + 2)
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
          i += 3
        }
      }
      return string
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-fail {
  width: 100%;
  padding: 30px 20px 0;
  .dot_ {
    display: flex;
    justify-content: flex-start;
    img {
      width: 27px;
      height: 20px;
    }
  }
  .result_ {
    font-size: 30px;
    color: #333;
    font-weight: 800;
    text-align: left;
    margin: 15px 0;
  }
  .title_ {
    color: #999999;
    font-size: 13px;
    line-height: 30px;
    text-align: left;
    margin-bottom: 25px;
    min-height: 100px;
  }
  .backbtn_ {
    border-radius: 14px;
    background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
    
  }
}
.auth {
  width: 100%;
  padding: 30px 20px 0;
  .title_ {
    color: #999999;
    font-size: 13px;
    line-height: 19px;
    text-align: left;
    margin-bottom: 25px;
  }
  .text {
    font-size: 13px;
    text-align: left;
  }
  .red {
    font-size: 13px;
    color: red;
  }
  .con_ {
    .con_1 {
      position: relative;
      display: flex;
      font-size: 15px;
      color: #333;
      margin-top: 20px;
      height: 48px;
      .tit_ {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        z-index: 1;
      }
      .cube-input-field {
        // padding-left: 1.8rem !important;
      }
      .picker {
        width: 100%;
        background: #f5f5f5;
        border-radius: 0.266667rem;
        padding-left: 90px;
        color: #707170;
        &:focus {
          outline: none;
          border: none;
        }
      }
    }
  }
  .read_ {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 30px;
    margin-top: 5px;
    .is_read {
      color: #FF7C6D;
    }
    .is_black {
      color: #000;
    }
  }
  .btn_ {
    border-radius: 14px;
  }
  .greybtn_ {
    background-color: #999999;
  }
  .okbtn_ {
    background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);

  }
}
</style>
